export function eventPanelMapperListResponse(json, headers) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
    })),
    total: headers.get("X-Total-Count") ? parseInt(headers.get("X-Total-Count").split("/").pop(), 10) : 1000,
  };
}

export function fixUpdateEventPanelId(json) {
  return {
    data: {...json, id: json.objectId,eventPanelId:json.objectId},
  };
}
export function fixGetManyEventPanel(json) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId
    })),
  };
}

export function fixCreateEventPanelId(params, json) {
  return {
    data: {...params.data, id: json.result.objectId},
  };
}

export function eventPanelMapperGetOneResponse(json) {
  return {
    data: {...json.result, id: json.result.objectId},
  };
}